import React from "react";
import "./Savoir.css";

const Savoir = () => {
  return (
    <section className="savoir" id="savoir">
      <div className="overlay"></div>
      <div className="savoir-container">
        
        {/* <div className="bloc">
          <h2>L’esprit de la friterie</h2>
          <p>
            Ma friterie, c’est avant tout une <strong>histoire de partage et de plaisir</strong> !  
            Ici, pas de chichis : des <strong>frites dorées à souhait</strong>, une <strong>ambiance conviviale</strong>  
            et la bonne humeur au rendez-vous.  
            Que ce soit sur une place de village, un événement ou une fête, je viens avec mon camion  
            pour <strong>créer un vrai moment de gourmandise</strong> autour de mes frites fraîches et de mes sauces.
          </p>
        </div> */}

        <div className="bloc">
          <h2>Une histoire de passion</h2>
          <p>
            Depuis <strong>2017</strong>, Mélanie régale les gourmands à la célèbre <strong>Braderie de Lille</strong> !  
            Avec son food truck <em>Les Tontons Friteurs</em>, elle partage sa bonne humeur et sa passion pour les <strong>frites croustillantes et généreuses</strong>, toujours servies dans une ambiance conviviale.
          </p>
        </div>

        <div className="bloc">
        <h2>Les Tontons Friteurs sous les projecteurs</h2>
        <p>
          Présente depuis <strong>2017</strong> à la célèbre <strong>Braderie de Lille</strong>, Mélanie partage sa bonne humeur et ses frites croustillantes avec des milliers de visiteurs.  
          Son food truck <em>Les Tontons Friteurs</em> est devenu un incontournable des gourmands du Nord !  
          Déjà en <strong>2012</strong>, l’aventure avait été mise à l’honneur dans un <strong>reportage du Journal de 13h de TF1</strong>,  
          à découvrir ici 👉  
          <a href="https://www.facebook.com/watch/?v=465256310172444" target="_blank" rel="noopener noreferrer">
            Voir le reportage
          </a>.
</p>
        </div>
      </div>
    </section>
  );
};

export default Savoir;
